// extracted by mini-css-extract-plugin
export default {"avatar-container":"HeaderCard_avatar-container__vYUh5","card-container":"HeaderCard_card-container__Ni3Bk","shipper-loader":"HeaderCard_shipper-loader__IStyJ"};